import React, { Component } from 'react';
import Select from 'react-select';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';


 class MobileDayitem extends Component {
  render() {
    const {
      OnSelectCar,
      selectedCar,
      options,
      product,
      placeholder,
      translate,
      input: { value, onChange, onBlur },OnSelectDay
    } = this.props;
    return (
      <div className="mobCatItem">
        <Select
          searchable={false}
          className="mobCalcSelect"
          value={value}
          placeholder={translate(placeholder)}
          onChange={s => {
            const value = s !== null ? Array.isArray(s) ? s.map(o => o.value) : s.value : '';
             onChange(s);
          }}  
          options={options}
          onBlur={() => {
            onBlur(value);
          }}
        />
      </div>
    );
  }
}
//   <DayItem
//   item={item}
//   key={item.productId}
//   selectDay={this.state.selectDay}
//   onClick={this.OnSelectDay}
//    />

{
  /* <div className={classnames('day-slide-item',
{ 'day-slide-item-selected': item.period === selectDay,})}
onClick={onClick.bind(this, item)} >
{item.period} {item.periodType}
</div> */
}


const mapStateToProps = state => ({
  translate: getTranslate(state.locale),
});
export default connect(mapStateToProps)(MobileDayitem) ;



// WEBPACK FOOTER //
// ./src/components/Calculator-board/Mobile-Day-Item/MobileDayitem.js